import {environment} from '../../../../environments/environment';

/**
 * Service to expose environment.ts to allow for better mocking in unit tests.
 */
export class EnvironmentConfiguration {
  /**
   * The current environment such as 'development' or 'staging'.
   */
  static env(): string {
    return environment.env;
  }

  /**
   * True or false based on variable 'enableProdMode'
   */
  static enableProdMode(): boolean {
    return environment.enableProdMode;
  }

  /**
   * @deprecated use CommerceDomainService
   * URL for accessing se services.
   */
  static apiBaseUrl(): string {
    return environment.apiBaseUrl;
  }

  /**
   * Base url from which to retrieve images.
   */
  static commerceImageBase(): string {
    return environment.commerceImageBase;
  }

  /**
   * @deprecated use CommerceDomainService
   * URL for accessing the Commerce API.
   */
  static commerceApiUri(): string {
    return environment.commerceApiUri;
  }

  /**
   * URL for accessing the Clare API.
   * @returns {string}
   */
  static clareApiUrl(): string {
    return environment.clareApiUrl;
  }
}
